<template>
  <div>
    <el-menu class="navbar" mode="horizontal">
<!--      <div class="btn-downloadC">-->
<!--        <div @click="dPlug">-->
<!--          <i class="el-icon-download downIcon"></i>下载发票采集插件-->
<!--        </div>-->
<!--        &lt;!&ndash; <a-->
<!--          href="//shuian-file.oss-cn-hangzhou.aliyuncs.com/goods/AI%E7%A8%8E%E5%8A%A1%E5%B8%88.zip"-->
<!--          class="btn-download"-->
<!--        >-->
<!--          <i class="el-icon-download"></i>下载发票采集插件-->
<!--        </a> &ndash;&gt;-->
<!--      </div>-->
      <div class="left-nav-box" v-if="isDemoMode">
        <router-link :to="{ name: 'homePage' }" class="btn btn-primary btn-back"
        >返回真实账号
        </router-link
        >
      </div>
      <div class="user-profile-container" trigger="click">
        <div class="user-profile-content">
          <div class="concat">联系我们：{{ contactUs }}</div>
          <div class="menu-icons">
            <span class="menu-icon red" @click="showActiviateDialog">
              <!-- <i class="icon iconfont">&#xe65f;</i> -->
              <img src="@/assets/test/agentIcon.png" class="agentIcon" alt/>
              <span class="icon-text icon-textN">兑换码激活</span>
            </span>

            <!-- <span class="menu-icon" @click="toHelp">
              <svg class="icon-symbol" aria-hidden="true">
                <use xlink:href="#iconbangzhu" />
              </svg>
              <span class="icon-text">帮助中心</span>
            </span> -->

            <!-- <span class="menu-icon">
              <a
                href="https://cschat-ccs.aliyun.com/index.htm?tntInstId=_1EiTA0W&scene=SCE00004242"
                target="_blank"
              >
                <i class="icon iconfont" style="color:#1890FF;">&#xe663;</i>

                <span class="icon-text">客服中心</span>
              </a>
            </span>-->

            <!-- <span class="menu-icon" @click="toMessage">
              <el-badge :value="messageNumber" class="item" v-if="messageNumber!=0">
                <i class="icon iconfont" style="color:#FF7718;">&#xe65e;</i>
                <span class="icon-text">消息中心</span>
              </el-badge>
              <el-badge class="item" v-else>
                <i class="icon iconfont" style="color:#FF7718;">&#xe65e;</i>
                <span class="icon-text">消息中心</span>
              </el-badge>
            </span>-->
          </div>
          <span style="fontSize:14px;lineHeight:21px;display:inline-block;margin-top:4px" @click="opendia">通知<span
            style="color:red">{{ length }}</span></span>
          <div class="user-profile-body-wrapper" v-if="dataLoaded">
            <el-dropdown>
              <div class="user-profile-body">
                <div class="username-wrapper">
                  <span class="user-name">
                    <template v-if="companyInfo.companyName">{{
                        companyInfo.companyName
                      }}</template>
                    <template v-else>未认证企业</template>
                  </span>
                  <i class="icon el-icon-caret-bottom"></i>
                </div>

                <!-- <img
                class="user-avatar"
                src="https://img.alicdn.com/tfs/TB1ONhloamWBuNjy1XaXXXCbXXa-200-200.png"
                />-->
              </div>
              <el-dropdown-menu slot="dropdown" class="user-dropdown">
                <router-link
                  :to="{ name: 'companyApply' }"
                  v-if="companyrenzheng.auditStatus == -1"
                >
                  <el-dropdown-item>去认证</el-dropdown-item>
                </router-link>
                <router-link to="/setUserCompany" v-else>
                  <el-dropdown-item>企业信息</el-dropdown-item>
                </router-link>
                <el-dropdown-item>
                  <span style="display: block" @click="logout">退出账号</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="menu-icons" v-if="dataLoaded">
            <div class="btn-verified" v-if="companyrenzheng.auditStatus == '1'">
              已认证
            </div>
            <div
              class="btn-verified"
              v-else-if="companyrenzheng.auditStatus == '2'"
            >
              认证失败
            </div>
            <div
              class="btn-verified"
              v-else-if="companyrenzheng.auditStatus == '0'"
            >
              认证中
            </div>
            <div class="btn-verified" v-else style="background: #007aff">
              未认证
            </div>
          </div>
        </div>
      </div>
    </el-menu>
    <DialogNotice ref="theDialogNotice" :length="length" @lengthchange="lengthchange($event)"></DialogNotice>

    <DialogActiviate
      ref="theDialogActiviate"
      @onDialogClose="handleActiviateDialogClose"
    ></DialogActiviate>
    <dialog-success
      ref="theDialogSuccess"
      :activationData="activationData"
    ></dialog-success>
    <reminder
      @closeToast="closeToast"
      v-if="reminderToast"
      class="reminder-toast"
      :option="option"
    ></reminder>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {messageList, mateGoods} from "@/api/api";
import DialogActiviate from "./components/DialogActivite";
import DialogSuccess from "./components/DialogSuccess";
import DialogNotice from "./components/DialogNotice";
import reminder from "./components/reminder";

import "@/assets/fonts/iconfont.css";
import store from "@/store";
import {logout, logoutAndClear} from "@/utils/helper";

export default {
  name: "NavBar",
  components: {
    DialogActiviate: DialogActiviate,
    DialogSuccess: DialogSuccess,
    reminder,DialogNotice
  },
  data() {
    return {
      length: 0,

      dataLoaded: false,
      res: [],
      errorstatus: 0,
      noread: 0,
      activationData: null,
      reminderToast: false,
      option: {
        cancel: true,
        close: true,
        submit: "下载",
        type: 1,
        content: "发票取值插件仅支持安装在windows系统内的电脑，是否继续下载？",
        icon: 1,
        title: "温馨提示"
      },
    };
  },
  computed: {
    ...mapState([
      "companyrenzheng",
      "companyInfo",
      "authorization",
      "messageNumber",
    ]),
    contactUs() {
      return this.$store.state.contactUs ? this.$store.state.contactUs : "0571-85055930"
    },
    isDemoMode() {
      return this.$route.fullPath.includes("/demo/");
    }
  },
  async mounted() {
    if(this.$route.query.fromHouTai == 'houtai') return;
    //消息中心
    // try {
    //   await this.$store.dispatch("loadMessageNumber");
    // } catch (error) {
    //   // eslint-disable-next-line no-console
    //   console.error(error);
    // }
    //企业信息
    try {
      await this.$store.cache.dispatch("loadCompanyInfo");
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
    try {
      await this.$store.cache.dispatch("loadCompanyRenzheng");
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }

    // await this.mategoods();
    // 获取uuid
    // 自动匹配行业bankID,goodsID,goodsName

    //this.getMessageList();
    this.dataLoaded = true;
  },
  methods: {
    lengthchange(e){
      this.length=e
    },
    async opendia() {
      this.$refs.theDialogNotice.showdia()
    },
    // 判断当前系统
    validataOS() {
      if (navigator.userAgent.indexOf("Window") > 0) {
        return 1;
      } else {
        return 2;
      }
    },
    closeToast() {
      this.reminderToast = false;
    },
    // 下载
    download() {
      var a = document.createElement("a");
      a.setAttribute(
        "href",
        "//shuian-file.oss-cn-hangzhou.aliyuncs.com/goods/AI%E7%A8%8E%E5%8A%A1%E5%B8%88.zip"
      );
      a.setAttribute("id", "startTelMedicine");
      // 防止反复添加
      if (document.getElementById("startTelMedicine")) {
        document.body.removeChild(document.getElementById("startTelMedicine"));
      }
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    dPlug() {
      // 先判断系统
      // 如果是window 则直接下载
      // 如果是mac 则弹窗
      let system = this.validataOS();
      if (system == 1) {
        this.download();
      } else {
        this.reminderToast = true;
      }
    },
    handleActiviateDialogClose(data) {
      if (data) {
        this.$refs.theDialogSuccess.dialogVisible = true;
        this.activationData = data;
      }
    },

    //打开激活弹出框
    showActiviateDialog() {
      this.$refs.theDialogActiviate.dialogVisible = true;
    },
    //获取消息未读数量
    getMessageList() {
      // const para = {
      //   type: "2",
      // };
      // messageList(para).then((res) => {
      //   var message1 = res.data.content;
      //   for (var i in message1) {
      //     if (message1[i].childList) {
      //       for (var j in message1[i].childList) {
      //         if (message1[i].childList[j].readStatus == 1) {
      //           this.noread += 1;
      //         }
      //       }
      //     }
      //   }
      // });
    },
    toMessage() {
      this.$router.push("/message/center");
    },
    toHelp() {
      this.$router.push("/helpCenter");
    },
    logout() {
      logoutAndClear(this.$store)

      this.$router.push({name: "login"});

    },
    mategoods() {
      let params = {
        token: this.$store.state.authorization,
      };
      mateGoods(params).then((res) => {
        this.$store.commit("setGoods", res.data);
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.el-message-box {
  border-radius: 10px;
}

.el-message-box__btns {
  button {
    width: 100px;
    height: 30px;
    line-height: 30px;
    border-radius: 15px;
    padding: 0;
    margin-top: 50px;

    span {
      display: inline-block;
      height: 30px;
      line-height: 30px;
    }
  }

  .el-button--default {
    color: #007aff;
    border-color: #007aff;
  }

  .el-button--primary {
    color: #fff;
    background: #007aff;
  }
}

.el-message-box__message {
  p {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(107, 120, 151, 1);
    line-height: 22px;
  }
}

.el-message-box__header {
  .el-message-box__title {
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(6, 35, 64, 1);
    line-height: 18px;
  }
}

.navbar {
  height: 60px;
  border-bottom: 0 none;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08), 0px 0px 4px 0px rgba(0, 0, 0, 0.02);
  position: fixed;
  z-index: 99;
  width: 100%;
  left: 0;
  top: 0;

  .user-profile-container {
    position: absolute;
    right: 20px;
    color: #666;
    height: 60px;
    display: flex;
    align-items: center;

    .user-profile-content {
      .concat {
        font-size: 14px;
        color: #2F54EB;
        margin-top: 4px;
      }

      display: flex;
    }

    .menu-icons {
      display: flex;
      align-items: center;

      .menu-icon {
        display: flex;
        align-items: center;
        font-size: 14px;
        padding: 0 20px;
        color: #666;

        .icon {
          display: inline-block;
          font-size: 14px;
          text-align: center;
          position: relative;
          top: 0px;
        }

        .icon-text {
          margin-left: 5px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.5);
        }

        .icon-textN {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(245, 34, 45, 1);
        }

        >>> .el-badge__content {
          background-color: #FF7718;
        }
      }

      .menu-icon.red {
        color: #F5222D;
      }
    }

    .user-profile-body-wrapper {
      position: relative;
      bottom: 2px;
      display: flex;
      align-items: center;
      padding: 0 5px 0 20px;

      .user-profile-body {
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        text-align: center;
        // padding-right: 14px;
      }

      .user-avatar {
        width: 32px;
        height: 32px;
        background: rgba(255, 255, 255, 1);
        border-radius: 50%;
      }

      .username-wrapper {
        margin-right: 3px;

        .user-name {
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.5);
          font-size: 14px;
          font-weight: 400;
          padding: 0 0 0 6px;
          max-width: 172px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          position: relative;
          top: 2px;
          margin-right: 3px;
        }

        .icon {
          color: #333;
        }
      }

      .user-department {
        font-size: 12px;
        color: rgba(102, 102, 102, 0.65);
      }
    }

    .btn-verified {
      text-align: center;
      line-height: 22px;
      width: 60px;
      height: 22px;
      background: #52C41A;
      border-radius: 5px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
    }
  }
}

.left-nav-box {
  color: #333;
  position: absolute;
  left: 176px;
  z-index: 100;
}

.btn-back {
  background: rgba(245, 34, 45, 1);
  border-radius: 4px;
  padding: 8px 24px;
  height: auto;
  line-height: 1.5;
  width: auto;
  margin-top: 12px;
  margin-left: 30px;
}

.btn-back:hover {
  background: rgba(245, 84, 45, 1);
}

.btn-downloadC {
  position: absolute;
  left: 210px;
  top: 10px;
  width: 168px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  background: #ADC6FF;
  border-radius: 4px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.8);
  cursor: pointer;
}
.btn-downloadC div{
  text-align: center;
}

.el-icon-download {
  margin-right: 10px;
}

.agentIcon {
  width: 16px;
  height: 16px;
}

.icon-textN {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 34, 45, 1);
  cursor: pointer;
}
</style>
